import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Feb 2026 fix: backend returns naive ISO datetimes from Mongo (no timezone).
 * JavaScript's Date() parses them as LOCAL time, causing wrong IST display.
 * This helper normalizes any datetime string to UTC so toLocaleString('...','Asia/Kolkata')
 * produces correct IST wall-clock output.
 */
function _utcDate(dateStr) {
  let s = String(dateStr);
  if (!/([Zz]|[+-]\d{2}:?\d{2})$/.test(s)) {
    s = s.replace(/\s+/, 'T') + 'Z';
  }
  return new Date(s);
}

/**
 * Format date to IST (Asia/Kolkata) - "01 Jan 2025"
 */
export function formatDate(dateStr) {
  if (!dateStr) return '-';
  try {
    return _utcDate(dateStr).toLocaleDateString('en-IN', {
      day: '2-digit', month: 'short', year: 'numeric',
      timeZone: 'Asia/Kolkata'
    });
  } catch (err) { return '-'; }
}

/**
 * Format date + time to IST - "01 Jan 2025, 02:30 PM"
 */
export function formatDateTime(dateStr) {
  if (!dateStr) return '-';
  try {
    return _utcDate(dateStr).toLocaleString('en-IN', {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: true,
      timeZone: 'Asia/Kolkata'
    });
  } catch (err) { return '-'; }
}

/**
 * Format time only to IST - "02:30 PM"
 */
export function formatTime(dateStr) {
  if (!dateStr) return '-';
  try {
    return _utcDate(dateStr).toLocaleTimeString('en-IN', {
      hour: '2-digit', minute: '2-digit', hour12: true,
      timeZone: 'Asia/Kolkata'
    });
  } catch (err) { return '-'; }
}

/**
 * Format date for DD/MM/YYYY display in IST
 */
export function formatDateShort(dateStr) {
  if (!dateStr) return '-';
  try {
    return _utcDate(dateStr).toLocaleDateString('en-IN', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      timeZone: 'Asia/Kolkata'
    });
  } catch (err) { return '-'; }
}
